import { render, staticRenderFns } from "./recycle.vue?vue&type=template&id=65c1fc78&scoped=true&"
import script from "./recycle.vue?vue&type=script&lang=js&"
export * from "./recycle.vue?vue&type=script&lang=js&"
import style0 from "./recycle.vue?vue&type=style&index=0&id=65c1fc78&lang=scss&scoped=true&"
import style1 from "./recycle.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c1fc78",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploy/private_library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65c1fc78')) {
      api.createRecord('65c1fc78', component.options)
    } else {
      api.reload('65c1fc78', component.options)
    }
    module.hot.accept("./recycle.vue?vue&type=template&id=65c1fc78&scoped=true&", function () {
      api.rerender('65c1fc78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/component/recycle.vue"
export default component.exports